import React from 'react';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Alert } from '../../../../shared/components/Alert';
import { Spinner } from '../../../../shared/components/Spinner';
import Header from '../components/Header';
import { ERROR_TITLES } from '../constants';
import { useUnlock } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const Unlock = () => {
  const { error, isLoading } = useUnlock();

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Unlock" />

        {isLoading && (
          <div className="flex justify-center">
            <Spinner />
          </div>
        )}

        {error && (
          <Alert
            description={error.message}
            icon={alertIcon}
            title={ERROR_TITLES.unlock.confirm}
            variant="destructive"
          />
        )}
      </div>
    </div>
  );
};

export default Unlock;
